import {
  formatDerInfoSeconds,
  displayGradW,
  displayFormattedNumberWithPrefixAndMultiplier
} from '../format';

import { UNIT_STRINGS } from '../appConstants';

export const DefaultDERControlSchema = {
  defaultControlNodeId: {
    // no toDisplayString, since it will not be displayed.
  },
  ddercResourceHref: {
    // no toDisplayString, since it will not be displayed.
  },
  controlTypes: {
    // no toDisplayString, since it will not be displayed.
  },
  description: {
    toDisplayString: value => value
  },
  setESDelay: {
    // seconds
    powerOfTen: 0, // to compensate for the durationFormatter
    toDisplayString: formatDerInfoSeconds
  },
  setESHighFreq: {
    displayUnits: UNIT_STRINGS.FREQUENCY,
    powerOfTen: -2,
    toDisplayString: displayFormattedNumberWithPrefixAndMultiplier
  },
  setESHighVolt: {
    displayUnits: UNIT_STRINGS.PERCENT,
    powerOfTen: -2,
    toDisplayString: displayFormattedNumberWithPrefixAndMultiplier
  },
  setESLowFreq: {
    displayUnits: UNIT_STRINGS.FREQUENCY,
    powerOfTen: -2,
    toDisplayString: displayFormattedNumberWithPrefixAndMultiplier
  },
  setESLowVolt: {
    displayUnits: UNIT_STRINGS.PERCENT,
    powerOfTen: -2,
    toDisplayString: displayFormattedNumberWithPrefixAndMultiplier
  },
  setESRampTms: {
    // seconds
    powerOfTen: 0,
    toDisplayString: formatDerInfoSeconds
  },
  setESRandomDelay: {
    // seconds
    powerOfTen: 0,
    toDisplayString: formatDerInfoSeconds
  },
  setGradW: {
    displayUnits: UNIT_STRINGS.MAXW_PER_SECOND,
    powerOfTen: -2,
    toDisplayString: displayGradW
  },
  setSoftGradW: {
    displayUnits: UNIT_STRINGS.MAXW_PER_SECOND,
    powerOfTen: -2,
    toDisplayString: displayGradW
  }
};
